export const theme = {
  textTransform: 'uppercase',
};
